import React from 'react'
import { Redirect, Route } from 'react-router-dom';
import LocalStorage from '../hook/LocalStorage';

function UnPaidRoute({ component: Component, ...rest }) {
  const { access_token, user } = LocalStorage();

  let expired = true;

  if (user) {
    if(user.membership){
      let expireAt = new Date(user.membership.expire_at);
      let currentDate = new Date();
    
      let hours = Math.round(expireAt - currentDate) / 36e5;
  
      if (hours > 0) {
        expired = false;
      }
      else{
        expired = true
      }
    }
    else{
      expired = true
    }
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (access_token && user.expire === 0 && user.membership && user.membership.package_type === "trial") {
          return <Component {...props} />;
        }
        if (access_token && user.expire === 1 && user.membership && user.membership.package_type === "trial") {
          return <Component {...props} />;
        }
        else if (access_token && user.expire === 1 && expired) {
          return <Component {...props} />;
        }
        else if (access_token && user.expire === 0 && expired) {
          return <Component {...props} />;
        }
        // else if (access_token && user.expire === 1) {
        //   return (
        //     <Redirect
        //       to={{
        //         pathname: "/dashboard",
        //         state: {
        //           from: props.location,
        //         },
        //       }}
        //     />
        //   );
        // }
        else {
          return <Component {...props} />;
          // return (
          //   <Redirect
          //     to={{
          //       pathname: "/event/type",
          //       state: {
          //         from: props.location,
          //       },
          //     }}
          //   />
          // );
        }
      }}
    />
  );
}

export default UnPaidRoute
